module.exports = __webpack_public_path__ + "static/media/app-connecte.c6a031e3.glb";